export default "__VITE_ASSET__D$mz8H_H__"